import '../sass/team-members-block.scss'
import './team-members-block'
